import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

export default class AppStoreAbility extends Ability {
  @service declare authz: AuthzService;

  get canView(): boolean {
    const locationAppPermissions = [
      Permission.APPS_LOCATION_APP_CREATE,
      Permission.APPS_LOCATION_APP_READ,
      Permission.APPS_LOCATION_APP_UPDATE,
      Permission.APPS_LOCATION_APP_DELETE,
    ];

    const companyAppPermissions = [
      Permission.APPS_COMPANY_APP_CREATE,
      Permission.APPS_COMPANY_APP_READ,
      Permission.APPS_COMPANY_APP_UPDATE,
      Permission.APPS_COMPANY_APP_DELETE,
    ];

    return (
      this.authz.hasAnyPermissionAtCurrentLocation(locationAppPermissions) ||
      this.authz.hasAnyPermissionAtCurrentCompany(companyAppPermissions)
    );
  }
}
